import React, { useEffect, useState } from "react";
import Translator from "Languages/Utility/Translator";
import PageTitle from "Components/PageTitle_IconCircle/PageTitle";
import { sa_NoticeColumn } from "Constants/TableColumns";
import RemoteTable from "Components/RemoteTable/RemoteTable";
import { read } from "Helpers/LocalStorage";
import StatusHandler from "Helpers/StatusHandler";
import { useDispatch, useSelector } from "react-redux";
import { GETSAAGAINNOTIFICATION } from "Stores/actionTypes";
import addNumToList from "Helpers/addNumToList";
import MuiPaper from "Components/MuiPaper/MuiPaper";
import BackDropLoading from "Components/BackDropLoading2/BackDropLoading";
import NotificationsService from "Services/http/endpoints/notifications/NotificationsService";
import AddNotice from "./components/AddNotice";

export default function NoticesIndex() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [sizePerPage, setSizePerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [tblData, setTblData] = useState([]);
  const [columns, setColumns] = useState([]);
  const { getNotificationAgain } = useSelector((state) => ({
    getNotificationAgain: state.notification.getNotificationAgain,
  }));

  useEffect(() => {
    onClear();
    onEnter();
  }, []);

  const onClear = async () => {
    setTblData([]);
  };

  const onEnter = async () => {
    setLoading(true);
    const _columns = [...sa_NoticeColumn];
    _columns[9].hidden = !read("Notice").accessDelete;
    setColumns(_columns);
    await getData();
    setLoading(false);
  };

  const onTableChange = async (type, { page, sizePerPage }) => {
    if (type === "pagination") {
      const params = {
        Limit: sizePerPage,
        Page: page,
      };
      await getData(params);
      setCurrentPage(page);
      setSizePerPage(sizePerPage);
    }
  };

  const getData = async (params = {}) => {
    try {
      setLoading(true);
      const response = await NotificationsService.getNotificationsAdmin({
        KeyGroup: read("groupAKey"),
        KeyUser: read("userAKey"),
        Limit: params.Limit ? params.Limit : sizePerPage,
        Page: params.Page ? params.Page : currentPage,
      });
      const err = StatusHandler(response);
      if (!err.isFail) {
        setTblData(
          addNumToList(
            response.data.Value,
            response.data.Pagination.Page,
            response.data.Pagination.Limit
          )
        );
        setCurrentPage(response.data.Pagination.Page);
        setSizePerPage(response.data.Pagination.Limit);
        setTotal(response.data.Pagination.Total);
      }
      setLoading(false);
    } catch (err) {
      console.error("[catch error]", err);
      setLoading(false);
    }
  };

  useEffect(() => {
    (async () => {
      if (getNotificationAgain) {
        await getData();
        dispatch({ type: GETSAAGAINNOTIFICATION, data: false });
      }
    })();
  }, [getNotificationAgain]);

  return (
    <>
      <div className="page-top-title-button my-3">
        <PageTitle title={<Translator id={"sami_notices"} />} />
        <div className="top-buttons">
          <AddNotice disabled={loading} />
        </div>
      </div>
      <BackDropLoading loading={loading} />
      <MuiPaper className="mt-3">
        {columns && columns.length !== 0 && (
          <RemoteTable
            data={tblData}
            columns={columns}
            page={currentPage}
            sizePerPage={sizePerPage}
            totalSize={total}
            onTableChange={onTableChange}
          />
        )}
      </MuiPaper>
    </>
  );
}
